<template>
  <div>
    <ui-modal
      ref="modal"
      :title="`Detalles Itinerario - ID ${titulo}`"
      @close="actionSetVisibleModalDetallesItinerario(false)"
      size="small"
    >
      <!-- Cuerpo -->
      <div class="d-flex flex-column p-3">
        <div class="d-flex">
          <div class="d-flex flex-column w-100">
            <div class="font-weight-bold">Semana</div>
            <div v-text="semanaModel"></div>
          </div>
          <div class="d-flex flex-column w-100">
            <div class="font-weight-bold">Servicio</div>
            <div v-text="servicioModel"></div>
          </div>
          <div class="d-flex flex-column w-100"></div>
        </div>
        <hr />
        <div class="d-flex mt-2">
          <div class="d-flex flex-column w-100">
            <div class="font-weight-bold">Naviera</div>
            <div v-text="navieraModel"></div>
          </div>
          <div class="d-flex flex-column w-100">
            <div class="font-weight-bold">Nave</div>
            <div v-text="naveModel"></div>
          </div>
          <div class="d-flex flex-column w-100">
            <div class="font-weight-bold">N° Viaje</div>
            <div v-text="numViajeModel"></div>
          </div>
        </div>
        <hr />
        <div class="d-flex mt-2">
          <div class="d-flex flex-column w-100">
            <div class="font-weight-bold">Puerto Embarque</div>
            <div v-text="puertoEmbarqueModel"></div>
          </div>
          <div class="d-flex flex-column w-100">
            <div class="font-weight-bold">ETD</div>
            <div v-text="etdModel"></div>
          </div>
          <div class="d-flex flex-column w-100">
            <div class="font-weight-bold">Tiempo Tránsito</div>
            <div v-text="ttModel"></div>
          </div>
        </div>
        <hr />
        <div class="d-flex mt-2">
          <div class="d-flex flex-column w-100">
            <div class="font-weight-bold">Puerto Destino</div>
            <div v-text="puertoDestinoModel"></div>
          </div>
          <div class="d-flex flex-column w-100">
            <div class="font-weight-bold">ETA</div>
            <div v-text="etaModel"></div>
          </div>
          <div class="d-flex flex-column w-100"></div>
        </div>
        <hr />
        <div class="d-flex mt-2">
          <div class="d-flex flex-column w-100">
            <div class="font-weight-bold">Stacking Inicio</div>
            <div v-text="stackingInicioModel"></div>
          </div>
          <div class="d-flex flex-column w-100">
            <div class="font-weight-bold">Stacking Término</div>
            <div v-text="stackingTerminoModel"></div>
          </div>
          <div class="d-flex flex-column w-100"></div>
        </div>
        <hr />
        <div class="d-flex mt-2">
          <div class="d-flex flex-column w-100">
            <div class="font-weight-bold">Corte Documental</div>
            <div v-text="corteDocumentalModel"></div>
          </div>
          <div class="d-flex flex-column w-100">
            <div class="font-weight-bold">Corte Documental Anticipado</div>
            <div v-text="corteDocumentalAntModel"></div>
          </div>
          <div class="d-flex flex-column w-100">
            <div class="font-weight-bold">Late Arrival</div>
            <div v-text="lateArrivalModel"></div>
          </div>
        </div>
      </div>
    </ui-modal>
  </div>
</template>

<script>
// Vuex
import { mapState, mapActions } from "vuex";

// UI Modal
import UiModal from "keen-ui/src/UiModal";

export default {
  props: ["data"],
  data() {
    return {
      id: "",
      semanaModel: "",
      servicioModel: "",
      navieraModel: "",
      naveModel: "",
      numViajeModel: "",
      puertoEmbarqueModel: "",
      etdModel: "",
      ttModel: "",
      puertoDestinoModel: "",
      etaModel: "",
      stackingInicioModel: "",
      stackingTerminoModel: "",
      corteDocumentalModel: "",
      corteDocumentalAntModel: "",
      lateArrivalModel: "",
      titulo: "",
      dataGeneral: this.data.data,
      data_complementaria: this.data.data_complementaria,
    };
  },
  components: {
    UiModal,
  },
  computed: {
    ...mapState("lineas", ["visibleModalDetallesItinerario"]),
  },
  methods: {
    ...mapActions("lineas", ["actionSetVisibleModalDetallesItinerario"]),

    openModal(ref) {
      this.$refs[ref].open();
    },

    closeModal(ref) {
      this.$refs[ref].close();
    },
  },
  watch: {
    visibleModalDetallesItinerario: function (_new) {
      let me = this;
      _new && me.openModal("modal");
    },
    data: function (_new) {
      // console.log(_new);

      if (_new) {
        //   //

        this.titulo = _new.data_complementaria.id;

        // console.log(this.titulo);

        this.semanaModel = _new.data[0];
        this.servicioModel = _new.data[4];
        this.navieraModel = _new.data[1];
        this.naveModel = _new.data[2];
        this.numViajeModel = _new.data[3];
        this.puertoEmbarqueModel = _new.data[5];
        this.etdModel = _new.data[6];
        this.ttModel = _new.data[9];
        this.puertoDestinoModel = _new.data[7];
        this.etaModel = _new.data[8];
        this.stackingInicioModel = _new.data_complementaria.stacking_from;
        this.stackingTerminoModel = _new.data_complementaria.stacking_to;
        this.corteDocumentalModel = _new.data_complementaria.cutoff_documental;
        this.corteDocumentalAntModel =
          _new.data_complementaria.cutoff_documental_ant;
        this.lateArrivalModel = _new.data_complementaria.late_arrival;
      }
    },
  },
};
</script>

<style>
.ui-modal--size-small > .ui-modal__wrapper > .ui-modal__container {
  width: 45% !important;
}
</style>
